import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';

let previousEvent = {
  previousEventId: '',
  previousTime: {} as Date
};

function safeParse<T = any>(input: string): T | undefined {
  try {
    return JSON.parse(input);
  } catch (ex) {
    return undefined;
  }
}

export default function useTrackClickEvents() {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    function onClick(ev: MouseEvent) {
      const { previousEventId, previousTime } = previousEvent;
      if (!(ev.target instanceof Element)) return;

      const target = ev.target.closest<HTMLElement>('[data-analytics-id]');
      const { analyticsId, analyticsAttributes } = target?.dataset || {};

      if (!analyticsId) return;
      if (
        analyticsId === previousEventId &&
        Date.now() - previousTime.getTime() < 500
      ) {
        previousEvent = {
          previousEventId: analyticsId,
          previousTime: new Date()
        };

        return;
      }

      previousEvent = {
        previousEventId: analyticsId,
        previousTime: new Date()
      };

      const eventSpecificAttributes = analyticsAttributes
        ? safeParse(analyticsAttributes)
        : {};
      const ddContext = datadogRum.getInternalContext();
      const attributesToSend = {
        ...eventSpecificAttributes,
        analyticsId: analyticsId,
        datadogSessionId: ddContext?.session_id,
        datadogViewId: ddContext?.view?.id
      };

      trackEvent('pp_click', attributesToSend);

      datadogRum.addAction(`${analyticsId}-clicked`);
    }

    document.addEventListener('click', onClick, false);

    return () => {
      document.removeEventListener('click', onClick);
    };
  }, [trackEvent]);
}
